module.exports = __webpack_public_path__ + "images/Eric_Alston.jpg?v=b9153ba636ffaf6711891588a992cea7";